import { ButtonBase, Container, Stack, Typography } from '@mui/material';
import {
  LOMBARD_PRIVACY_POLICY_LINK,
  TERMS_OF_SERVICE_LINK,
} from 'modules/common/const';
import { useTranslation } from 'modules/i18n';
import { FooterLogo } from './FooterLogo';
import { translation } from './translation';
import { useFooterStyles } from './useFooterStyles';

export function Footer(): JSX.Element {
  const { keys, t } = useTranslation(translation);
  const { classes } = useFooterStyles();

  const links = [
    {
      href: TERMS_OF_SERVICE_LINK,
      text: keys.tos,
    },
    {
      href: LOMBARD_PRIVACY_POLICY_LINK,
      text: keys.policy,
    },
  ];

  return (
    <Container
      component="footer"
      maxWidth={false}
      sx={{
        display: 'flex',
        justifyContent: { xs: 'flex-start', sm: 'space-between' },
        alignItems: 'center',
        py: 3,
        color: 'text.secondary',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <FooterLogo />

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        gap={2}
        alignItems="center"
        width="100%"
        sx={{
          justifyContent: {
            xs: 'center',
            sm: 'space-between',
          },
        }}
      >
        <Stack direction="row" alignItems="center" gap={2}>
          {links.map(
            ({ href, text }) =>
              !!href && (
                <ButtonBase
                  key={href}
                  className={classes.link}
                  href={href}
                  target="_blank"
                  rel="norefferer"
                >
                  {t(text)}
                </ButtonBase>
              ),
          )}
        </Stack>

        <Typography variant="body2">
          {t(keys.copyright, { year: new Date().getFullYear() })}
        </Typography>
      </Stack>
    </Container>
  );
}
